// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application {\n  height: 100vh;\n  overflow-y: scroll;\n  background: #f2f6f7 !important;\n}\n.select-referee-card .v-text-field__details {\n  display: none !important;\n}\n.user-pic-sm {\n  width: 2rem;\n  border-radius: 0.25rem;\n}", ""]);
// Exports
module.exports = exports;
